const { accountType } = require('@transfeeradev/api-enums');
const SEVENT_OR_EIGHT_DIGITS_REGEX = /^\b0*([1-9][0-9]{6,7}|0)\b$/;

const santanderSchema = {
  account: {
    maxLength: 8,
    minLength: 7,
    pattern: SEVENT_OR_EIGHT_DIGITS_REGEX
  },
  accountType: {
    allowedTypes: [accountType.CONTA_CORRENTE, accountType.CONTA_POUPANCA]
  }
};

module.exports = santanderSchema;
